import LogoWinners from "../../resources/images/logo.svg";

// icons
// import Icon_Casino from "../../resources/icons/casino.webp";
// import Icon_Home from "../../resources/icons/home.webp";
// import Icon_Favorites from "../../resources/icons/favorites.webp";
// import Icon_Fixture from "../../resources/icons/fixture.webp";
// import Icon_Live from "../../resources/icons/live.webp";
// import Icon_Slots from "../../resources/icons/slot-machine.webp";
// import Icon_Virtual from "../../resources/icons/virtual.webp";
import Icon_BarChart from "../../resources/icons/bar-chart-reload.webp";
import CircleCheck from "../../resources/icons/checkbox-marked-circle.webp";

// logos
import LogoWinnersHand from "../../resources/images/hand.webp";

// menu images
import Rugby from "../../resources/images/menurugby.svg";
import Dart from "../../resources/images/menudart.svg";
import Aussie from "../../resources/images/menuaussierules.svg";
import MMA from "../../resources/images/menumma.svg";
import Soccer from "../../resources/images/menusoccer.svg";
import IceHockey from "../../resources/images/menuicehokey.svg";
import MenuBasketball from "../../resources/images/menubasketball.svg";
import MenuMMA from "../../resources/images/menumma.svg";
import MenuTennis from "../../resources/images/menutennis.svg";
import MenuCricket from "../../resources/images/menucriket.svg";
import VolleyBall from "../../resources/images/menuvollyball.svg";

// my account icons
import MyAccountBetsIcon from "../../resources/images/my-account-bets.svg";
import MyAccountDepositeIcon from "../../resources/images/my-account-deposite.svg";
import MyAccountWithdrawalIcon from "../../resources/images/my-account-withdrawal.svg";
import MyAccountChangePasswordIcon from "../../resources/images/my-account-change-password.svg";
import MyAccountTransactionsIcon from "../../resources/images/my-account-transactions.svg";
import MyAccountPersonalInfoIcon from "../../resources/images/my-account-personal-info.svg";
import MyAccountAddProviderIcon from "../../resources/images/my-account-add-provider.svg";

// other icons
import DownArrow from "../../resources/images/chevron-down.svg";
// import PlusEighteenDarkMode from "../../resources/images/plus18.svg";
import BinIcon from "../../resources/images/delete.svg";
import RedBinIcon from "../../resources/images/red-trash.svg";
import DarkMoon from "../../resources/images/dark-moon.svg";
import CloseIcon from "../../resources/images/close-fill.svg";
import HidePasswordIcon from "../../resources/images/eye-fill.svg";
import ShowPasswordIcon from "../../resources/images/eye-fill-white.svg";
import LoadingIcon from "../../resources/images/antd-icons/loading.svg";
import MenuIcon from "../../resources/images/antd-icons/menu.svg";
import ProfileIcon from "../../resources/images/antd-icons/profile.svg";
import DollarIcon from "../../resources/images/antd-icons/dollar.svg";
import UpArrow from "../../resources/images/antd-icons/up.svg";
import ChevronUpIcon from "../../resources/images/antd-icons/chevron-up.svg";
import FilePdfIcon from "../../resources/images/antd-icons/file-pdf.svg";
import CheckCircleIcon from "../../resources/images/antd-icons/check-circle.svg";
import QuestionCircleIcon from "../../resources/images/antd-icons/question-circle.svg";
import PlusIcon from "../../resources/images/antd-icons/plus.svg";
import MinusIcon from "../../resources/images/antd-icons/minus.svg";
import LockIcon from "../../resources/images/antd-icons/lock.svg";
import CopyIcon from "../../resources/images/antd-icons/copy.svg";
import UploadIcon from "../../resources/images/antd-icons/upload.svg";

// top bets
// import TopBets1 from "../../resources/top-bets/studiom1/1.webp";
// import TopBets2 from "../../resources/top-bets/studiom1/2.webp";
// import TopBets3 from "../../resources/top-bets/studiom1/3.webp";

// strips
import Strip_Soccer from "../../resources/images/strip_soccer.webp";
import Strip_Mask from "../../resources/images/strip_mask.webp";

// general images
import LT from "../../resources/images/lt.webp";
import Image_Maintenence from "../../resources/images/maintenence.webp";
import Check from "../../resources/images/check.webp";
import Thumb from "../../resources/images/thumb.webp";
import NotificationIcon from "../../resources/images/notification-icon.svg";
import RewardsIcon from "../../resources/images/rewards-icon.svg";
// import SilverStatusImage from "../../resources/images/silver-status.svg";
import ProgressBarStar from "../../resources/images/star.svg";
// import WheelSpin from "../../resources/images/wheel.svg";
import WheelArrow from "../../resources/images/wheel-arrow.svg";
import Hand from "../../resources/images/finger.png";
// import Shine from "../../resources/images/shine.png";
import LiveTrackerIcon from "../../resources/images/live-tracker.png";
import DarkStar from "../../resources/images/dark-star.png";
import DarkCup from "../../resources/images/dark-cup.png";
import LoadingBackground from "../../resources/images/loading-background.webp";
// const LoadingBackground = "/loading-background.png";
import Loading from "../../resources/images/loading.png";
import InfoIcon from "../../resources/images/info.svg";
import PasswordRuleInfoIcon from "../../resources/images/password-rule-info.svg";
import NoNotification from "../../resources/images/no-notification.svg";

// test icons
import SoccerTest from "../../resources/images/Soccer-test.png";
import DummyTeam from "../../resources/images/Borussia_Dortmund_logo 1.png";
import DeleteIcon from "../../resources/images/delete.png";
import TurnOffIcon from "../../resources/images/notification-off.png";
// import JackpotFrame from "../../resources/images/shape.png";
import RotateIcon from "../../resources/images/rotate.svg";
import LeftArrowIcon from "../../resources/images/LA.png";
import RightArrowIcon from "../../resources/images/RA.png";
import LuckyNumberStar from "../../resources/images/fav-star.svg";
import Calender from "../../resources/images/calender.png";
import Time from "../../resources/images/time.png";
import CanceledEvent from "../../resources/images/canceled-event.png";
// import HeartIcon from "../../resources/images/heart.png";
// import ChatIcon from "../../resources/images/chat.png";
// import HomeIcon from "../../resources/images/home.png";

// test banners for slots
// import SlotsTest1 from "../../resources/images/test1-slots.png";
// import SlotsTest2 from "../../resources/images/test2-slots.png";
// import SlotsTest3 from "../../resources/images/test3-slots.png";
// import SlotsTest4 from "../../resources/images/test4-slots.png";

// games
// import AviatorGame from "../../resources/images/aviator-game.png";
// import NewJackpot from "../../resources/images/new-jackpot.png";
// import SpiritEygptGame from "../../resources/images/sprirt-egypt-game.png";
// import SpecialGame from "../../resources/images/special-game.png";
import Crown from "../../resources/images/crown.png";
import Joker from "../../resources/images/joker.png";
import Wolf from "../../resources/images/wolf.png";

// bet services
// import PromotionIcon from "../../resources/images/promotions.webp";
// import LandingIcon from "../../resources/images/landing.webp";

// general
import PromoIcon from "../../resources/images/promoIcon.png";
import InfoCircle from "../../resources/images/info-circle.png";

// verify email
import ConfirmationLogo from "../../resources/images/confirmation-logo.png";

// flags
import usFlag from "../../resources/images/us.webp";
import lrFlag from "../../resources/images/lr.webp";


const images = {
  LogoWinners,
  LogoWinnersHand,
  // Icon_Home,
  // Icon_Favorites,
  // Icon_Fixture,
  // Icon_Live,
  // Icon_Virtual,
  Icon_BarChart,
  // Icon_Slots,
  // Icon_Casino,

  Image_Maintenence,

  Strip_Soccer,
  Strip_Mask,

  LT,
  DarkMoon,
  CloseIcon,
  HidePasswordIcon,
  ShowPasswordIcon,
  LoadingIcon,
  MenuIcon,
  ProfileIcon,
  DollarIcon,
  UpArrow,
  ChevronUpIcon,
  FilePdfIcon,
  CheckCircleIcon,
  QuestionCircleIcon,
  PlusIcon,
  MinusIcon,
  LockIcon,
  CopyIcon,
  UploadIcon,

  Rugby,
  Dart,
  Aussie,
  MMA,
  Soccer,
  IceHockey,

  MyAccountBetsIcon,
  MyAccountDepositeIcon,
  MyAccountWithdrawalIcon,
  MyAccountChangePasswordIcon,
  MyAccountTransactionsIcon,
  MyAccountPersonalInfoIcon,
  MyAccountAddProviderIcon,

  // TopBets1,
  // TopBets2,
  // TopBets3,

  CircleCheck,
  Check,
  Thumb,

  DownArrow,
  // PlusEighteenDarkMode,
  BinIcon,
  RedBinIcon,

  MenuBasketball,
  MenuMMA,
  MenuTennis,
  MenuCricket,
  VolleyBall,

  NotificationIcon,
  RewardsIcon,
  // SilverStatusImage,

  ProgressBarStar,
  // WheelSpin,
  WheelArrow,

  Hand,
  // Shine,

  LiveTrackerIcon,
  DarkStar,
  DarkCup,

  LoadingBackground,
  Loading,

  InfoIcon,
  PasswordRuleInfoIcon,
  SoccerTest,
  DummyTeam,

  
  DeleteIcon,
  TurnOffIcon,
  // JackpotFrame,

  NoNotification,
  RotateIcon,

  LeftArrowIcon,
  RightArrowIcon,

  LuckyNumberStar,
  Calender,
  Time,
  CanceledEvent,
  // HeartIcon,
  // ChatIcon,
  // HomeIcon,


  // SlotsTest1,
  // SlotsTest2,
  // SlotsTest3,
  // SlotsTest4,


  // AviatorGame,
  // NewJackpot,
  // SpiritEygptGame,
  // SpecialGame,
  Crown,

  Joker,
  Wolf,
  // PromotionIcon,
  // LandingIcon,
  PromoIcon,


  ConfirmationLogo,
  InfoCircle,

  usFlag,
  lrFlag,


};

export default images;
